export class SubmerchantAuthError extends Error {
  isExpected: boolean;

  constructor(message: string, isExpected = false) {
    super(message);
    this.isExpected = isExpected;
    this.name = 'SubmerchantAuthError';
  }
}

export class SubmerchantAuthExpectedError extends SubmerchantAuthError {
  constructor(message: string) {
    super(message, true);
  }
}

export class SubmerchantAuthSessionExpiredError extends SubmerchantAuthError {
  constructor() {
    super('Session expired', false);
  }
}

export class TimeoutError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'TimeoutError';
  }
}

const isSubmerchantAuthError = (error: any): error is SubmerchantAuthError => {
  return !!(error && error instanceof SubmerchantAuthError);
};

export const isSubmerchantAuthExpectedError = (error: any): boolean => {
  return isSubmerchantAuthError(error) && error.isExpected;
};
